import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const IG_URL = "https://www.instagram.com/pareagonlife/";

const Footer = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const goToPageTop = (path) => {
    navigate(path);
    window.setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, 0);
  };

  const handleNewsletterSubmit = (event) => {
    event.preventDefault();

    if (!email.trim()) {
      setMessage("Enter your email.");
      return;
    }

    setMessage("You’re on the list.");
    setEmail("");
  };

  const InternalFooterLink = ({ to, children }) => (
    <button
      type="button"
      onClick={() => goToPageTop(to)}
      className="text-left text-base font-light text-[#aaa297] transition-colors duration-300 hover:text-[#f3eee5]"
    >
      {children}
    </button>
  );

  return (
    <footer
      id="contact"
      className="border-t border-[#8e6d36]/25 bg-[#090908] text-[#d7d0c5]"
    >
      <div className="mx-auto max-w-[1440px] px-6 py-16 sm:px-10 lg:px-16 lg:pb-12 lg:pt-24">
        <div className="grid gap-14 md:grid-cols-2 lg:grid-cols-[1.4fr_0.8fr_0.8fr_1.15fr] lg:gap-16">
          <div className="foot-brand">
            <Link
              to="/"
              onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "auto" })}
              className="inline-block text-xl tracking-[0.38em] text-[#ecd7ad] transition-opacity duration-300 hover:opacity-70"
              aria-label="PΛREΛGON home"
            >
              P<span className="text-[#c99f5f]">Λ</span>RE
              <span className="text-[#c99f5f]">Λ</span>GON
            </Link>

            <p className="mt-8 max-w-[330px] text-base font-light leading-8 text-[#aaa297]">
              Y2K-inspired runners for the arrival. Designed in Los Angeles,
              dropped in limited pairs.
            </p>
          </div>

          <div className="foot-col">
            <h2 className="text-[11px] uppercase tracking-[0.34em] text-[#d4aa67]">
              Shop
            </h2>
            <ul className="mt-8 space-y-5">
              <li>
                <InternalFooterLink to="/product/yellow">
                  The 860
                </InternalFooterLink>
              </li>
              <li>
                <InternalFooterLink to="/">All colourways</InternalFooterLink>
              </li>
              <li>
                <InternalFooterLink to="/help">Gift cards</InternalFooterLink>
              </li>
              <li>
                <InternalFooterLink to="/help">Sizing guide</InternalFooterLink>
              </li>
            </ul>
          </div>

          <div className="foot-col">
            <h2 className="text-[11px] uppercase tracking-[0.34em] text-[#d4aa67]">
              Help
            </h2>
            <ul className="mt-8 space-y-5">
              <li>
                <InternalFooterLink to="/help">Shipping</InternalFooterLink>
              </li>
              <li>
                <InternalFooterLink to="/help">Returns</InternalFooterLink>
              </li>
              <li>
                <InternalFooterLink to="/help">Track order</InternalFooterLink>
              </li>
              <li>
                <InternalFooterLink to="/help">Contact</InternalFooterLink>
              </li>
            </ul>
          </div>

          <div className="foot-col news">
            <h2 className="text-[11px] uppercase tracking-[0.34em] text-[#d4aa67]">
              Join the list
            </h2>
            <p className="mt-8 max-w-[330px] text-base font-light leading-8 text-[#aaa297]">
              First access to drops and restocks — before they hit the feed.
            </p>

            <form
              onSubmit={handleNewsletterSubmit}
              className="mt-8 border-b border-[#8e6d36]/45"
            >
              <div className="flex items-center gap-4 pb-3">
                <label htmlFor="footer-email" className="sr-only">
                  Email address
                </label>
                <input
                  id="footer-email"
                  type="email"
                  value={email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                    setMessage("");
                  }}
                  placeholder="Your email"
                  className="min-w-0 flex-1 bg-transparent text-sm text-[#f3eee5] outline-none placeholder:text-[#69645d]"
                />
                <button
                  type="submit"
                  className="shrink-0 text-[10px] uppercase tracking-[0.3em] text-[#d4aa67] transition-colors duration-300 hover:text-[#f3eee5]"
                >
                  Sign up
                </button>
              </div>
            </form>

            {message && (
              <p className="mt-3 text-xs tracking-[0.08em] text-[#8f887e]" role="status">
                {message}
              </p>
            )}
          </div>
        </div>

        <div className="mt-20 flex flex-col gap-8 border-t border-[#8e6d36]/20 pt-8 text-[11px] uppercase tracking-[0.18em] text-[#8f887e] sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 PΛREΛGON — Los Angeles</p>

          <div className="flex flex-wrap gap-x-8 gap-y-4">
            <a
              href={IG_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-300 hover:text-[#f3eee5]"
            >
              Instagram
            </a>
            <a
              href="https://www.tiktok.com/@pareagonlife"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-300 hover:text-[#f3eee5]"
            >
              TikTok
            </a>
            <a
              href="mailto:pareagonlife@gmail.com"
              className="transition-colors duration-300 hover:text-[#f3eee5]"
            >
              Email
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;